import { render } from "./EditorSlideMoreDropdown.vue?vue&type=template&id=61463ed9&scoped=true"
import script from "./EditorSlideMoreDropdown.vue?vue&type=script&lang=js"
export * from "./EditorSlideMoreDropdown.vue?vue&type=script&lang=js"

import "./EditorSlideMoreDropdown.vue?vue&type=style&index=0&id=61463ed9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61463ed9"]])

export default __exports__